import { createContext, useCallback, useContext, useState } from "react";

const Ctx = createContext(null);

export function UIProvider({ children }) {
  const [enquiry, setEnquiry] = useState({ open: false, type: "General enquiry", businessType: "" });
  const [panel, setPanel] = useState(null);

  const openEnquiry = useCallback((type = "General enquiry", businessType = "") => {
    setPanel(null);
    setEnquiry({ open: true, type, businessType });
  }, []);
  const closeEnquiry = useCallback(() => setEnquiry((e) => ({ ...e, open: false })), []);

  return (
    <Ctx.Provider value={{ enquiry, openEnquiry, closeEnquiry, panel, openPanel: setPanel, closePanel: () => setPanel(null) }}>
      {children}
    </Ctx.Provider>
  );
}

export const useUI = () => useContext(Ctx);
